<template>
  <div id="app">
    <loading v-show="isLoading" />
    <the-header class="fixed z-50 h-12" :class="isMobile() ? 'w-full' : 'w-96 m-fixed-header-left border-pc'" />
    <template v-if="!isMobile()">
      <menu-left />
      <menu-right />
    </template>
    <div class="container" :class="isMobile() ? 'w-max-full' : 'w-96 mx-auto border-pc'">
      <router-view class="pt-12"/>
    </div>
    <the-footer :class="isMobile() ? 'w-max-full' : 'w-96 mx-auto border-pc'" />
  </div>
</template>

<script>
import store from './store';
import { mapGetters } from 'vuex'
import './assets/common.css'
import './assets/stylesheets/main.scss'
import './assets/menu.scss'
import Constants from './constants'

import TheHeader from './components/organisms/TheHeader.vue'
import TheFooter from './components/organisms/TheFooter'
import MenuRight from './components/organisms/MenuRight.vue'
import MenuLeft from './components/organisms/MenuLeft.vue'
import Loading from './components/organisms/Loading.vue'

export default {
  name: 'App',
  components: {
    TheHeader,
    TheFooter,
    MenuLeft,
    MenuRight,
    Loading
  },
  computed: {
    ...mapGetters({
      isLoading: 'loading/isLoading'
    }),
  },
  created () {
    if (this.$route.params.lang) {
      store.dispatch('user/setLang', this.$route.params.lang)
    } else {
      store.dispatch('user/setLang', 'ja')
    }
    const areaId = this.$route.params.areaId || this.$route.params.poiId
    const id = Constants.MX1_ORAGA_LOGO_LIST[areaId]
    if (id) {
      if (areaId !== this.$store.getters['user/getAreaId']) {
        store.dispatch('user/setAreaId', areaId)
        store.dispatch('user/resetFilter')
      }
    } else {
      store.dispatch('user/resetAreaId')
    }
    this.$store.dispatch('translation/fetchAll')
      .then(() => {
        const translation = this.$store.getters['translation/getTranslation']()
        for (let lang in translation) {
          this.$i18n.mergeLocaleMessage(lang, translation[lang])
        }
      })
  },
  methods : {
    createTitleDesc : function(){
      // タイトルを設定
      document.title = Constants.SITE_TITLE
    },
    isMobile() {
      const userAgent = window.navigator.userAgent.toLowerCase();
      if (userAgent.indexOf("iphone") != -1 || userAgent.indexOf("android") != -1) {
        return true;
      } else {
        return false;
      }
    }
  },
  mounted : function(){
    this.createTitleDesc();
  }
}
</script>
